export function buildDeepLinkUrl(): string {
  const shop = window.shopify?.config?.shop || window.shopify?.shop;
  const apiKey = process.env.SHOPIFY_API_KEY;

  return `https://${shop}/admin/themes/current/editor?context=apps&template=product&appEmbed=${apiKey}/cod-form&target=mainSection`;
}
